export default "__VITE_ASSET__DJaFt70$__"